"use strict";
/**
 * @class Breadcrumb
 * @description Breadcrumb component
 * @spec https://confluence.oci.oraclecorp.com/display/UX/Breadcrumb
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var index_1 = require("../index");
var Messages = require("../codegen/Messages");
var util_1 = require("../utils/util");
var warning_1 = require("../utils/warning");
/**
 * OUI breadcrumb component.
 * Breadcrumbs indicate location within a navigational hierarchy.
 *
 * @oui-component Breadcrumb
 */
var Breadcrumb = function (_a) {
    // let currentCount = 0;
    var items = _a.items, ariaLabel = _a.ariaLabel, label = _a.label;
    var crumbs = items.map(function (item, i) {
        var href = item.href, id = item.id, label = item.label, testId = item.testId, current = item.current, ariaCurrent = item.ariaCurrent;
        var itemProps = __assign({ id: id, "data-test-id": testId, key: "breadcrumb-" + i }, util_1.ariaProps({ current: current || ariaCurrent }));
        // const hasCurrent = current !== undefined;
        // if (hasCurrent === true) currentCount += 1;
        warning_1.default(ariaCurrent !== undefined && current === undefined, "`ariaCurrent` is being deprecated, use `current` instead");
        return href ? (React.createElement("li", __assign({}, itemProps),
            React.createElement(index_1.Link, { href: href, textStyle: index_1.LinkTextStyle.None }, label))) : (React.createElement("li", __assign({}, itemProps), label));
    });
    // @todo - add this back in if UI wants plugins to implement aria-current, currently they do not want to ask plugins to do so
    // warning(
    //   currentCount !== 1,
    //   "You must include aria-current on one and only one breadcrumb item"
    // );
    return (React.createElement("ul", { "aria-label": label || ariaLabel || Messages.Breadcrumb.breadcrumb(), className: "oui-breadcrumb", role: "navigation" }, React.Children.toArray(crumbs)));
};
Breadcrumb.defaultProps = {
    // not used for actual default, just here to satisfy that this deprecated prop is a required prop in v4
    ariaLabel: ""
};
exports.default = Breadcrumb;
//# sourceMappingURL=Breadcrumb.js.map